module.exports = __webpack_public_path__ + "static/media/bonian_bg.50fc60b8.mp4";